module.exports = __webpack_public_path__ + "static/sprout-2e7ff02de9360cb5ca2018b6c7fe46bb.png";